export const ON_EVENTS_MOUNT = '@MyEvents/ON_MY_EVENTS_MOUNT';
export const ON_EVENTS_MOUNT_ERROR = '@MyEvents/ON_MY_EVENTS_MOUNT_ERROR';
export const ON_MY_EVENTS_STATUS_FILTER_CHANGE = 'ON_MY_EVENTS_STATUS_FILTER_CHANGE';
export const ON_DUPLICATE_EVENT_CLICKED = 'ON_DUPLICATE_EVENT_CLICKED';
export const ON_DUPLICATE_EVENT_CLOSED = 'ON_DUPLICATE_EVENT_CLOSED';
export const UPDATE_DUPLICATE_EVENT_TITLE = 'UPDATE_DUPLICATE_EVENT_TITLE';
export const UPDATE_DUPLICATE_EVENT_START_DATE = 'UPDATE_DUPLICATE_EVENT_START_DATE';
export const UPDATE_DUPLICATE_EVENT_END_DATE = 'UPDATE_DUPLICATE_EVENT_END_DATE';
export const UPDATE_DUPLICATE_EVENT_START_TIME = 'UPDATE_DUPLICATE_EVENT_START_TIME';
export const UPDATE_DUPLICATE_EVENT_END_TIME = 'UPDATE_DUPLICATE_EVENT_END_TIME';
export const TOGGLE_DUPLICATE_EVENT_ACCESS_KEYS = 'TOGGLE_DUPLICATE_EVENT_ACCESS_KEYS';
export const TOGGLE_DUPLICATE_EVENT_DISCOUNT_CODES = 'TOGGLE_DUPLICATE_EVENT_DISCOUNT_CODES';
export const ON_DUPLICATE_EVENT_TITLE_ERROR = 'ON_DUPLICATE_EVENT_TITLE_ERROR';
export const ON_DUPLICATE_EVENT_DATE_ERROR = 'ON_DUPLICATE_EVENT_DATE_ERROR';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const CLEAR_FLASH_MESSAGE = 'CLEAR_FLASH_MESSAGE';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';
export const ON_SHOW_LOADING_STATE = 'ON_SHOW_LOADING_STATE';

export const onMyEventsMount = () => ({ type: ON_EVENTS_MOUNT });

// Actions
export const onMyEventsStatusFilterChange = (value) => ({
  type: ON_MY_EVENTS_STATUS_FILTER_CHANGE,
  payload: value
});

export const onDuplicateEventClicked = (id, title, start, end) => ({
  type: ON_DUPLICATE_EVENT_CLICKED,
  payload: { id, title, start, end }
});

export const onDuplicateEventClosed = () => ({
  type: ON_DUPLICATE_EVENT_CLOSED
});

export const onUpdateDuplicateEventTitle = (value) => ({
  type: UPDATE_DUPLICATE_EVENT_TITLE,
  payload: value
});

export const onUpdateDuplicateEventStartDate = (value) => ({
  type: UPDATE_DUPLICATE_EVENT_START_DATE,
  payload: value
});

export const onUpdateDuplicateEventEndDate = (value) => ({
  type: UPDATE_DUPLICATE_EVENT_END_DATE,
  payload: value
});

export const onUpdateDuplicateEventStartTime = (value) => ({
  type: UPDATE_DUPLICATE_EVENT_START_TIME,
  payload: value
});

export const onUpdateDuplicateEventEndTime = (value) => ({
  type: UPDATE_DUPLICATE_EVENT_END_TIME,
  payload: value
});

export const onToggleDuplicateEventAccessKeys = () => ({
  type: TOGGLE_DUPLICATE_EVENT_ACCESS_KEYS
});

export const onToggleDuplicateEventDiscountCodes = () => ({
  type: TOGGLE_DUPLICATE_EVENT_DISCOUNT_CODES
});

export const onDuplicateEventTitleError = () => ({
  type: ON_DUPLICATE_EVENT_TITLE_ERROR
});

export const onDuplicateEventDateError = () => ({
  type: ON_DUPLICATE_EVENT_DATE_ERROR
});

export const clearFlashMessage = () => ({
  type: CLEAR_FLASH_MESSAGE
});

export const showFlashMessage = (level, message) => ({
  type: ADD_FLASH_MESSAGE,
  payload: {
    level,
    message
  }
});

export const onUpdateSearchText = (value) => ({
  type: UPDATE_SEARCH_TEXT,
  payload: value
});

export const onShowLoadingState = () => ({
  type: ON_SHOW_LOADING_STATE
});



// WEBPACK FOOTER //
// ./src/modules/my-events/actions.js